export default __webpack_public_path__ + "static/media/selected_icon.79ad3e04.svg";